import React, {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {Redirect} from 'react-router-dom';
import {TextField, Button} from '@material-ui/core';

import "./Auth.css"

import {checkValidity} from "../../Utils/utils";
import * as actions from "../../store/actions";
import {LoadingIcon} from "../../components/Loading/Loading";

const initialInputFieldState = {
    email: {
        label: "Email",
        elementConfig: {
            type: "email",
            placeholder: "Your Email Address"
        },
        value: "",
        validation: {
            required: true,
            isEmail: true
        },
        valid: false,
        changed: false
    },
    password: {
        label: "Password",
        elementConfig: {
            type: "password",
            placeholder: "Password"
        },
        value: "",
        validation: {
            required: true,
            minLength: 6
        },
        valid: false,
        changed: false
    }
}

const Auth = (props) => {
    const [inputFields, setInputFields] = useState(initialInputFieldState)
    const [isSignUp, setIsSignUp] = useState(true)
    const [isFormValid, setIsFormValid] = useState(true)

    const isAuth = useSelector(state => state.auth.token !== null)
    const loading = useSelector(state => state.auth.loading)
    const error = useSelector(state => state.auth.error)

    const dispatch = useDispatch()
    const onAuthInit = useCallback(() => dispatch(actions.authInit()), [dispatch])
    const onAuth = (email, password, isSignup) => dispatch(actions.auth(email, password, isSignup))

    useEffect(() => {
        onAuthInit()
    }, [onAuthInit])

    useEffect(() => {
        let flag = true
        for (let key in inputFields) {
            flag = flag && inputFields[key].valid
        }
        setIsFormValid(flag)

        document.title = "Authenticate | Hacker News clone"
    }, [inputFields])

    const onSubmitHandler = (event) => {
        event.preventDefault()
        onAuth(inputFields.email.value, inputFields.password.value, isSignUp)
    }

    const switchAuthHandler = () => {
        setIsSignUp(state => !state)
    }

    const inputChangedHandler = (event, inputName) => {
        const updatedInputField = {
            ...inputFields[inputName]
        };
        updatedInputField.value = event.target.value
        updatedInputField.valid = checkValidity(updatedInputField.value, updatedInputField.validation)
        updatedInputField.changed = true
        setInputFields(state => ({...state, [inputName]: updatedInputField}))
    }

    const inputElementArray = []
    for (let key in inputFields) {
        inputElementArray.push({
            id: key,
            ...inputFields[key]
        });
    }
    let inputElements = inputElementArray.map(inputElement => {
        let error = false
        if (!inputElement.valid && inputElement.changed) {
            error = true
        }
        return (
            <TextField
                error={error}
                key={inputElement.id}
                label={inputElement.label}
                type={inputElement.elementConfig.type}
                placeholder={inputElement.elementConfig.placeholder}
                defaultValue={inputElement.value}
                onChange={(event) => inputChangedHandler(event, inputElement.id)}
                fullWidth
                margin="dense"
                size="small"
            />
        )
    });

    const redirectTo = new URLSearchParams(props.location.search).get("goto")

    return (
        <div className="Auth">
            {isAuth ? (<Redirect to={redirectTo ? "/" + redirectTo : ""}/>) : null}
            <h2>Authentication</h2>
            <h4>You have to be logged in order to submit.</h4>
            <p className={error ? "Invalid" : "Valid"}>{error ? error : "Error message"}</p>
            <form onSubmit={onSubmitHandler}>
                {inputElements}
                <div className="Buttons">
                    <Button
                        variant="contained"
                        style={{width: '150px'}}
                        disabled={!isFormValid}
                        type="Submit"
                        endIcon={loading ? <LoadingIcon size="1.5rem" /> : null}
                    >
                        {isSignUp ? "Sign Up" : "Sign In"}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={switchAuthHandler}
                    >
                        Switch to {!isSignUp ? "Sign Up" : "Sign In"}
                    </Button>
                </div>
            </form>
        </div>
    )
}

export default Auth;